import getText from "../../../../../utils/language.js"
import { GlobalContext } from "../../../../../utils/globalprovider.js";
import "./tabs.css"
import React from "react";

class ParamCheckBox extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props)
        this.state = 
        {
            value: this.props.value,
            defaultvalue: this.props.value,

        }

        if ("defaultvalue" in this.props)
        {
            this.state.defaultvalue = this.props.defaultvalue;
            this.state.checkdefault = true;
        }

        this.handleCheckBox = this.handleCheckBox.bind(this)



    }
    handleCheckBox()
    {
        var newvalue = !this.state.value;
        this.setState({value: newvalue});
        this.props.onchange(this.props.paramnumber, newvalue);
    }

    render()
    {
        const title = getText(this.props.text.cat, this.props.text.scat, this.context.language);


        
        var tcolor="white";
        var checkdefault = false;
        var defaultvalue = this.props.value;
        if (this.props.coid > 0)
        {
            if ("defaultvalue" in this.props)
            {
                defaultvalue = this.props.defaultvalue;
                checkdefault = true;
            }
        }

        if (checkdefault)
        {
            if (this.state.value != defaultvalue)
                tcolor="#FF9800";
        }


        return(
            <div className ="tabsettingslidertext">
                <label htmlFor={"checkbox"+this.props.id}>
                <input type="checkbox" id={"checkbox"+this.props.id}
                checked={this.state.value}
                onChange={this.handleCheckBox} />
                <span style={{color:tcolor}}>
                    &nbsp;{title}
                </span>
                </label>
            </div>
        )
    }
}

export default ParamCheckBox
